export default "__VITE_ASSET__BHsBoWPv__"